import { Inject, inject, Injectable, LOCALE_ID, Optional, RendererFactory2, DOCUMENT } from '@angular/core'
import { RuntimeService } from 'src/app/service/runtime.service'
import { Environment } from 'src/environments/environment'
import { CookieKey, ED_INJECT_EXPRESS_REQUEST, ED_INJECT_LOCALE_ID, PageLocales } from 'src/server/server.data'

import { MetaService } from 'src/app/service/meta/meta.service'
import { CookieInterface } from 'src/tools/cookie.tools'
import { DomService } from 'src/app/service/dom.service'
import { Request } from 'express'
import { PageContext, Paynow4SaleType, RedirectorService } from 'src/app/service/redirector.service'
import { Meta } from '@angular/platform-browser'
import { ActivatedRoute } from '@angular/router'
import { BehaviorSubject, takeUntil } from 'rxjs'
import { OfferExpiredNoteComponent } from 'src/app/elements/offer-expired-note/offer-expired-note.component'
import { MatDialog } from '@angular/material/dialog'
import { PriceSuggestionComponent } from 'src/app/elements/price-suggestion/price-suggestion.component'

declare const window: any

@Injectable()
export class SourceService {
  protected userToken$ = new BehaviorSubject<string>('')

  constructor (
    protected runtimeService: RuntimeService,
    protected redirectorService: RedirectorService,
    protected rendererFactory2: RendererFactory2,
    @Inject(DOCUMENT) protected document: Document,
  ) {}

  boot () {
    if (this.runtimeService.isServer()) {
      return
    }

    const renderer2 = this.rendererFactory2.createRenderer(null, null)
    const script = renderer2.createElement('script')
    renderer2.setAttribute(script, 'defer', 'true')
    renderer2.setAttribute(script, 'src', Environment.url.app + '/js/service/entry.service.js')
    renderer2.appendChild(this.document.body, script)

    const context = this.redirectorService.getContext()
    let defaultSource: { source:string, payload: any } = {
      source: 'redirector_unknown',
      payload: {
        locale: context.i18n.locale,
        config: context.config,
      },
    }

    switch (context.config.type) {
      case 'paynow':
        defaultSource = {
          source: 'redirector_paynow',
          payload: {
            locale: context.i18n.locale,
            domain: context.config.name,
            template: context.config.template,
          },
        }
        break;
      case '4sale':
        defaultSource = {
          source: 'redirector_4sale',
          payload: {
            locale: context.i18n.locale,
            domain: context.config.name,
            template: context.config.template,
          },
        }
        break;
      case 'error':
        defaultSource = {
          source: 'redirector_error',
          payload: {
            locale: context.i18n.locale,
            template: context.config.template,
            domain: context.config.name,
          },
        }
        break;
      case 'landing':
        if (context.config.template === 'recently-caught') {
          defaultSource = {
            source: 'redirector_recent_catch',
            payload: {
              locale: context.i18n.locale,
              domain: context.config.name,
            },
          }
        }
        break;
    }

    script.onload = () => {
      this.userToken$.next(new window.StatisticsService(defaultSource, false).getToken())
    }
  }

  public getUserToken$ () {
    return this.userToken$
  }
}
